//#region constants import
import { ICON_DELETE } from "../../Constants/IconConstants";
//#endregion

//#region styles import
import "./CustomTrainingRoadMapAction.style.scss";
//#endregion

/**
 * Action of customtraining page table
 */

const CustomTrainingRoadMapAction = ({ value, ActionsProps }) => {
  return (
    <div className="custom-training-roadmap-action">
      <button
        className="gsta-button-outlined"
        onClick={() => ActionsProps.deleteStep(value)}
      >
        <i className={ICON_DELETE} />
      </button>
    </div>
  );
};

export default CustomTrainingRoadMapAction;
